const checkout = document.querySelector(".wc-block-checkout");

if (checkout) {
  const customCheckoutPageeHeader = () => {
    const pageHeader = document.createElement("div");
    pageHeader.classList.add("custom-page-title");

    const pageHeaderH1 = document.createElement("h1");

    pageHeaderH1.innerHTML = "Checkout";

    pageHeader.appendChild(pageHeaderH1);

    checkout.insertBefore(pageHeader, checkout.firstChild);

    const backToShopLink = document.createElement("a");
    backToShopLink.classList.add("back-to-shop-link");
    backToShopLink.innerHTML = "or return to shop";
    backToShopLink.href = "/shop";

    pageHeader.appendChild(backToShopLink);
  };

  customCheckoutPageeHeader();
}
